export default __webpack_public_path__ + "static/media/refreshIcon.0b71b907.svg";